import React from "react";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Add from "@mui/icons-material/Add";
import FilterList from "@mui/icons-material/FilterList";
import { Link as RouterLink } from "react-router-dom";

interface ITableToolbarProps {
  name: string;
  create: string;
}

const TableToolbar = ({ name, create }: ITableToolbarProps) => (
  <Toolbar sx={{ borderBottom: 1, borderColor: "grey.300" }}>
    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
      {name}
    </Typography>
    <Stack direction="row" spacing={1}>
      <Tooltip title="Add">
        <IconButton component={RouterLink} to={create}>
          <Add />
        </IconButton>
      </Tooltip>
      <Tooltip title="Filter">
        <IconButton>
          <FilterList />
        </IconButton>
      </Tooltip>
    </Stack>
  </Toolbar>
);

export default TableToolbar;
